import type { AdminManagerBrief } from '../../../api';

type Props = {
  managers: AdminManagerBrief[];
  selectedId: number | null;
  unassignedOnly?: boolean;
  showAll?: boolean;
  onSelect: (managerId: number | null, unassigned?: boolean) => void;
  hapticSelection: () => void;
};

export function CrmManagerFilterChips({
  managers,
  selectedId,
  unassignedOnly,
  showAll,
  onSelect,
  hapticSelection,
}: Props) {
  const chip = (active: boolean) =>
    active
      ? { background: 'rgba(246,173,85,0.2)', color: '#F6AD55', border: '1px solid rgba(246,173,85,0.45)' }
      : { background: 'rgba(255,255,255,0.04)', color: 'var(--text-3)', border: '1px solid var(--border-subtle)' };

  const label = (m: AdminManagerBrief) =>
    m.first_name || m.username || `#${m.id}`;

  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1 -mx-1 px-1">
      {showAll && (
        <button
          type="button"
          onClick={() => {
            hapticSelection();
            onSelect(null, false);
          }}
          className="press shrink-0 px-3 py-2 rounded-xl text-[11px] font-bold touch-manipulation min-h-[44px]"
          style={chip(selectedId == null && !unassignedOnly)}
        >
          Все
        </button>
      )}
      {managers.map((m) => (
        <button
          key={m.id}
          type="button"
          onClick={() => {
            hapticSelection();
            onSelect(m.id, false);
          }}
          className="press shrink-0 px-3 py-2 rounded-xl text-[11px] font-bold touch-manipulation min-h-[44px] max-w-[140px] truncate"
          style={chip(selectedId === m.id && !unassignedOnly)}
        >
          {label(m)}
        </button>
      ))}
      <button
        type="button"
        onClick={() => {
          hapticSelection();
          onSelect(null, true);
        }}
        className="press shrink-0 px-3 py-2 rounded-xl text-[11px] font-bold touch-manipulation min-h-[44px]"
        style={chip(!!unassignedOnly)}
      >
        Без менеджера
      </button>
    </div>
  );
}
